import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMusteriList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMusteriList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VCustomer: any[];
  Boss_VCustomer_dummy: any[];
  Boss_VCustomerHeader: any[];
  Boss_VCustomerHeader_dummy: any[];
  Boss_VCustomerTotal: any[];
  Boss_VCustomerTotal_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp115365Visible: "visible" | "hidden";
  isComp330937Visible: "visible" | "hidden";
}

export class MusteriList_ScreenBase extends React.PureComponent<
  IMusteriList_ScreenProps,
  any
> {
  musterilist_456384_value_kuikaSelectBoxRef: React.RefObject<any>;
  musterilist_222385_value_kuikaTableRef: React.RefObject<any>;
  musterilist_251279_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ff4d195a-b59d-4406-ab4d-4d0491d86161",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 721294, PropertyName: "label", Value: "Profil" },
        { Id: 338128, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 305315, PropertyName: "value", Value: "Müşteri Hesapları" },
        { Id: 588216, PropertyName: "value", Value: "Varlıklarım / Borçlarım" },
        { Id: 450762, PropertyName: "value", Value: "Alacaklarım" },
        { Id: 179082, PropertyName: "value", Value: "Borçlarım" },
        { Id: 834055, PropertyName: "value", Value: "Net Varlık" },
        {
          Id: 456384,
          PropertyName: "placeholder",
          Value: "Borç/Alacak bakiye",
        },
        { Id: 542451, PropertyName: "placeholder", Value: "Unvan..." },
        { Id: 31976, PropertyName: "label", Value: "Ara" },
        { Id: 950435, PropertyName: "label", Value: "Temizle" },
        {
          Id: 222385,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 627176, PropertyName: "title", Value: "Title" },
        { Id: 389949, PropertyName: "value", Value: "Unvan" },
        {
          Id: 523286,
          PropertyName: "value",
          Value: "[datafield:accountdescription]",
        },
        { Id: 593319, PropertyName: "value", Value: "Kod" },
        { Id: 480138, PropertyName: "value", Value: "[datafield:accountcode]" },
        { Id: 487479, PropertyName: "value", Value: "Para Birimi" },
        {
          Id: 707390,
          PropertyName: "value",
          Value: "[datafield:doccurrencycode]",
        },
        { Id: 577040, PropertyName: "value", Value: "Bakiye" },
        { Id: 294943, PropertyName: "value", Value: "[datafield:balance]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.musterilist_456384_value_kuikaSelectBoxRef = React.createRef();
    this.musterilist_542451_value_kuikaTextInputRef = React.createRef();
    this.musterilist_222385_value_kuikaTableRef = React.createRef();
    this.musterilist_251279_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VCustomer: [],
      Boss_VCustomerHeader: [],
      Boss_VCustomerTotal: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_456384: [
        { key: "0", text: "Tümü" },
        { key: "1", text: "Borç Bakiyeliler" },
        { key: "2", text: "Alacak Bakiyeliler" },
      ],
      isComp115365Visible: "hidden",
      isComp330937Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("musterilist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MusteriListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("musterilist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("musterilist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MusteriListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MusteriListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriList/MusteriListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomer = result?.data.boss_VCustomer;

    stateVars.Boss_VCustomerHeader = result?.data.boss_VCustomerHeader;

    stateVars.Boss_VCustomerTotal = result?.data.boss_VCustomerTotal;
    formVars.musterilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].creditBalance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].creditBalance
        : null
    );
    formVars.musterilist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].debitBalance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].debitBalance
        : null
    );
    formVars.musterilist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].balance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].balance
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.musterilist_430969_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.musterilist_430969_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_827141 =
      stateVars.Boss_VCustomerHeader ?? this.state.Boss_VCustomerHeader;
    formVars.musterilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].creditBalance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].creditBalance
        : null
    );

    formVars.musterilist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].debitBalance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].debitBalance
        : null
    );

    formVars.musterilist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerTotal !== undefined
        ? stateVars.Boss_VCustomerTotal?.length > 0
          ? stateVars.Boss_VCustomerTotal[0].balance
          : null
        : this.state.Boss_VCustomerTotal?.length > 0
        ? this.state.Boss_VCustomerTotal[0].balance
        : null
    );

    stateVars.dataSource_222385 =
      stateVars.Boss_VCustomer ?? this.state.Boss_VCustomer;
    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MusteriListComponent_961468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MusteriList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "780045",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_721294_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MusteriList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_338128_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_456384_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_456384_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriList/MusteriListComponent_456384_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomer = result?.data.boss_VCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListComponent_456384_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriListComponent_456384_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "musterilist_251279_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_222385 =
      stateVars.Boss_VCustomer ?? this.state.Boss_VCustomer;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_31976_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_456384_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_251279_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriList/MusteriListComponent_31976_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomer = result?.data.boss_VCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListComponent_31976_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriListComponent_31976_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VCustomer ?? this.state.Boss_VCustomer;
    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_950435_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "musterilist_456384_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "musterilist_542451_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "musterilist_251279_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListComponent_950435_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MusteriListComponent_950435_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriList/MusteriListComponent_950435_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomer = result?.data.boss_VCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListComponent_950435_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriListComponent_950435_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VCustomer ?? this.state.Boss_VCustomer;
    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_91072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MusteriDetay",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "musterilist_222385_value",
          "accountDescription"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MusteriDetay",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "musterilist_222385_value",
          "accountCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MusteriList",
      "MusteriDetay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriListComponent_251279_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_456384_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musterilist_251279_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriList/MusteriListComponent_251279_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomer = result?.data.boss_VCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriListComponent_251279_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriListComponent_251279_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.Boss_VCustomer ?? this.state.Boss_VCustomer;
    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    formVars.musterilist_251279_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].totalCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].totalCount
        : null
    );
    formVars.musterilist_251279_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomer !== undefined
        ? stateVars.Boss_VCustomer?.length > 0
          ? stateVars.Boss_VCustomer[0].pageCount
          : null
        : this.state.Boss_VCustomer?.length > 0
        ? this.state.Boss_VCustomer[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [780045, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MusteriListPageInit();
    }
  }
}
